import Icon from "../../../../components/ui/Icon";
import { Header, Badge, Texts, Title, Subtitle, RequiredTag, OptionalTag } from "./StepGroupHeader.styles";

interface StepGroupHeaderProps {
  index: number;
  title: string;
  subtitle?: string;
  required: boolean;
  done: boolean;
}

export default function StepGroupHeader({ index, title, subtitle, required, done }: StepGroupHeaderProps) {
  return (
    <Header>
      <Badge $done={done}>{done ? <Icon name="check" size={13} strokeWidth={2.8} /> : index}</Badge>
      <Texts>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </Texts>
      {required ? (
        <RequiredTag $done={done}>
          {done && <Icon name="check" size={11} strokeWidth={3} />}
          {done ? "OK" : "OBRIGATÓRIO"}
        </RequiredTag>
      ) : (
        <OptionalTag>OPCIONAL</OptionalTag>
      )}
    </Header>
  );
}
